// Only styles with correct 1024×1365 portrait format images
export const approvedStyles = [
  // Professional Styles
  {
    id: 'golden_halo_spotlight',
    name: 'Golden Halo Spotlight',
    category: 'professional',
    thumbnail: '/assets/styles/style_golden_halo_spotlight_thumb.jpg',
    description: 'Dramatic spotlight with golden halo effect'
  },
  {
    id: 'orange_backdrop_editorial',
    name: 'Orange Editorial',
    category: 'professional',
    thumbnail: '/assets/styles/style_orange_backdrop_editorial_thumb.jpg',
    description: 'Vibrant orange backdrop for editorial portraits'
  },
  {
    id: 'magazine_cover_reborn',
    name: 'Magazine Cover',
    category: 'professional',
    thumbnail: '/assets/styles/style_magazine_cover_reborn_thumb.jpg',
    description: 'High-fashion magazine cover quality'
  },
  {
    id: 'editorial_documentary_hybrid',
    name: 'Documentary Style',
    category: 'professional',
    thumbnail: '/assets/styles/style_editorial_documentary_hybrid_thumb.jpg',
    description: 'Editorial documentary hybrid portrait'
  },

  // Artistic Styles
  {
    id: 'surreal_double_exposure_bw',
    name: 'Surreal Double Exposure',
    category: 'artistic',
    thumbnail: '/assets/styles/style_surreal_double_exposure_bw_thumb.jpg',
    description: 'Artistic double exposure in black and white'
  },
  {
    id: 'openai_rembrandt_bw',
    name: 'Rembrandt Style',
    category: 'artistic',
    thumbnail: '/assets/styles/style_openai_rembrandt_bw_thumb.jpg',
    description: 'Classic Rembrandt-inspired black and white portrait'
  },
  {
    id: 'low_light_bill_henson',
    name: 'Low Light Art',
    category: 'artistic',
    thumbnail: '/assets/styles/style_low_light_bill_henson_thumb.jpg',
    description: 'Artistic low light photography style'
  },

  // Creative Styles
  {
    id: 'blue_hour_editorial_portrait',
    name: 'Blue Hour Editorial',
    category: 'creative',
    thumbnail: '/assets/styles/style_blue_hour_editorial_portrait_thumb.jpg',
    description: 'Twilight photography with deep blue tones'
  },
  {
    id: 'bw_suit_against_wall',
    name: 'Business Noir',
    category: 'creative',
    thumbnail: '/assets/styles/style_bw_suit_against_wall_thumb.jpg',
    description: 'Stylish black and white business portrait'
  },
  {
    id: 'red_gradient_background_lux_mag',
    name: 'Luxury Red Gradient',
    category: 'creative',
    thumbnail: '/assets/styles/style_red_gradient_background_lux_mag_thumb.jpg',
    description: 'Luxurious red gradient magazine style'
  },
  {
    id: 'fire_and_ice_droplets',
    name: 'Fire & Ice',
    category: 'creative',
    thumbnail: '/assets/styles/style_fire_and_ice_droplets_thumb.jpg',
    description: 'Dramatic contrast of fire and ice elements'
  },

  // Vintage/Film Styles
  {
    id: 'editorial_film_noir',
    name: 'Editorial Film Noir',
    category: 'vintage',
    thumbnail: '/assets/styles/style_editorial_film_noir_thumb.jpg',
    description: 'Classic black and white with cinematic lighting'
  },
  {
    id: 'openai_leica_monochrom',
    name: 'Leica Monochrome',
    category: 'vintage',
    thumbnail: '/assets/styles/style_openai_leica_monochrom_thumb.jpg',
    description: 'Premium Leica camera monochrome style'
  },
  {
    id: 'dark_moody_bw_hp5',
    name: 'Dark Moody Film',
    category: 'vintage',
    thumbnail: '/assets/styles/style_dark_moody_bw_hp5_thumb.jpg',
    description: 'Moody black and white film photography'
  },

  // Futuristic Styles
  {
    id: 'cyberpunk_city_neon',
    name: 'Cyberpunk City',
    category: 'futuristic',
    thumbnail: '/assets/styles/style_cyberpunk_city_neon_thumb.jpg',
    description: 'Futuristic cityscape with neon lights'
  }
];